/**
 * Cart recommendations add-to-cart functionality
 */
document.addEventListener('DOMContentLoaded', function() {
  // Setup the click handlers for add buttons
  function setupAddButtons() {
    var forms = document.querySelectorAll('.cart-recommendations');
    forms.forEach(function(form) {
      if (!form.hasAttribute("data-cart-recommendations-setup")) {
        form.setAttribute("data-cart-recommendations-setup", "1");
        var addButtons = form.querySelectorAll('.cart-add-button');
        
        addButtons.forEach(function(button) {
          button.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation(); // Stop event bubbling
            
            var variantId = this.getAttribute('data-variant-id');
            var originalText = this.textContent;
            
            // Change button text to loading state with animated dots
            this.disabled = true;
            
            // Create animated dots
            var dotsCount = 0;
            var dotsInterval = setInterval(() => {
              dotsCount = (dotsCount + 1) % 4;
              var dots = '';
              for (var i = 0; i < dotsCount; i++) {
                dots += '.';
              }
              this.textContent = dots || '.';
            }, 300);
            
            // Add item to cart via Ajax
            fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: variantId,
                quantity: 1
              })
            })
            .then(response => response.json())
            .then(data => {
              // Use the theme's ajaxCart load method to refresh the cart drawer
              if (typeof theme !== 'undefined' && theme.ajaxCart && typeof theme.ajaxCart.update === 'function') {
                theme.ajaxCart.update();
              }
              
              // Clear the dots animation
              clearInterval(dotsInterval);
              
              // Reset button after delay
              setTimeout(() => {
                this.textContent = originalText;
                this.disabled = false;
              }, 800);
            })
            .catch(error => {
              console.error('Error adding item to cart:', error);
              // Clear the dots animation
              clearInterval(dotsInterval);
              this.textContent = originalText;
              this.disabled = false;
            });
            
          });
        });
      }
    });
    setTimeout(setupAddButtons, 10);
  }
  
  // Initial setup
  setupAddButtons();
});
